import { atom } from 'recoil';

const ErrorState = atom({
  key: 'error',
  default: undefined,
});

const LoadingState = atom<boolean>({
  key: 'loading',
  default: false,
});

export { ErrorState, LoadingState };
